// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
fuse-corpus-details-sidenav {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  height: 100%;
  /*
  titre
  prévisu
  Durée
  Concept
  Chapitres
  Niveau

   */
}
fuse-corpus-details-sidenav .content {
  flex: 1;
}
fuse-corpus-details-sidenav .content > .header {
  padding: 0;
  min-height: 0;
  height: auto;
  background: none;
}
fuse-corpus-details-sidenav .content > .header .title {
  font-weight: 500;
  font-size: 14px;
}
fuse-corpus-details-sidenav .content .file-details__actions {
  display: flex;
}
fuse-corpus-details-sidenav .content .file-details__actions mat-icon {
  font-size: 2.75rem;
}
fuse-corpus-details-sidenav .preview {
  min-height: 120px;
  border: 1px solid orange;
  margin-bottom: 14px;
}
fuse-corpus-details-sidenav .offline-switch {
  padding-bottom: 16px;
  font-weight: 500;
}
fuse-corpus-details-sidenav .title {
  padding: 16px 0;
}
fuse-corpus-details-sidenav table {
  width: 100%;
  text-align: left;
  margin-top: 14px;
}
fuse-corpus-details-sidenav th,
fuse-corpus-details-sidenav td {
  padding: 4px 0;
}
fuse-corpus-details-sidenav th {
  font-weight: 500;
}
fuse-corpus-details-sidenav tr.type {
  text-transform: capitalize;
}
fuse-corpus-details-sidenav tr.owner {
  text-transform: capitalize;
}
video,
audio {
  max-width: 100%;
}

img,
video,
audio {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/corpus/core/components/corpus-sidenavs/corpus-details/corpus-details.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EA6DA;;;;;;;;IAAA;AAlDF;AATE;EACE,OAAA;AAWJ;AATI;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAWN;AATM;EACE,gBAAA;EACA,eAAA;AAWR;AANM;EACE,aAAA;AAQR;AANQ;EACE,kBAAA;AAQV;AAFE;EACE,iBAAA;EACA,wBAAA;EACA,mBAAA;AAIJ;AADE;EACE,oBAAA;EACA,gBAAA;AAGJ;AAAE;EACE,eAAA;AAEJ;AACE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AACJ;AAEE;;EAEE,cAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAsCI;EACE,0BAAA;AApCN;AA6CI;EACE,0BAAA;AA3CN;AAmDA;;EAEE,eAAA;AAjDF;;AAoDA;;;EAGE,eAAA;AAjDF","sourcesContent":["fuse-corpus-details-sidenav {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 0 auto;\r\n  height: 100%;\r\n\r\n  .content {\r\n    flex: 1;\r\n\r\n    > .header {\r\n      padding: 0;\r\n      min-height: 0;\r\n      height: auto;\r\n      background: none;\r\n\r\n      .title {\r\n        font-weight: 500;\r\n        font-size: 14px;\r\n      }\r\n    }\r\n\r\n    .file-details {\r\n      &__actions {\r\n        display: flex;\r\n\r\n        mat-icon {\r\n          font-size: 2.75rem;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .preview {\r\n    min-height: 120px;\r\n    border: 1px solid orange;\r\n    margin-bottom: 14px;\r\n  }\r\n\r\n  .offline-switch {\r\n    padding-bottom: 16px;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .title {\r\n    padding: 16px 0;\r\n  }\r\n\r\n  table {\r\n    width: 100%;\r\n    text-align: left;\r\n    margin-top: 14px;\r\n  }\r\n\r\n  th,\r\n  td {\r\n    padding: 4px 0;\r\n  }\r\n\r\n  th {\r\n    font-weight: 500;\r\n  }\r\n\r\n  td {\r\n  }\r\n\r\n  /*\r\n  titre\r\n  prévisu\r\n  Durée\r\n  Concept\r\n  Chapitres\r\n  Niveau\r\n\r\n   */\r\n  tr {\r\n    &.created {\r\n    }\r\n\r\n    &.changed {\r\n    }\r\n\r\n    &.auteur {\r\n    }\r\n\r\n    &.source {\r\n    }\r\n\r\n    &.format {\r\n    }\r\n\r\n    &.description {\r\n    }\r\n\r\n    &.size {\r\n    }\r\n\r\n    &.type {\r\n      text-transform: capitalize;\r\n    }\r\n\r\n    &.size {\r\n    }\r\n\r\n    &.location {\r\n    }\r\n\r\n    &.owner {\r\n      text-transform: capitalize;\r\n    }\r\n\r\n    &.opened {\r\n    }\r\n  }\r\n}\r\n\r\nvideo,\r\naudio {\r\n  max-width: 100%;\r\n}\r\n\r\nimg,\r\nvideo,\r\naudio {\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
